import styled from 'styled-components'

const FormSubHeading = styled.h3`
  display: block;
  width: 100%;
  font-size: 1.25rem;
  font-weight: 500;
  padding-bottom: 10px;
  color: #13174f;
  border-bottom: ${props => (props.noBottomBorder ? 'none' : '1px solid #ccc')};
  margin: ${props => (props.margin ? props.margin : '0')};
`

export default FormSubHeading
